import { render, staticRenderFns } from "./View-Edit-User-Page.vue?vue&type=template&id=687810c2"
import script from "./View-Edit-User-Page.vue?vue&type=script&lang=js"
export * from "./View-Edit-User-Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports